import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import TableCell from '@mui/material/TableCell';
import type { ReactNode } from 'react';
import { CreativeIdLine } from '../../creatives/CreativeIdLine';
import { ThumbnailPreview } from '../../creatives/ThumbnailPreview';

const THUMB_SIZE = 80;

export interface ReportCreative {
  assetId: string;
  creativeId: string | null;
  thumbnailUrl: string | null;
  previewUrl: string | null;
}

interface CreativeCellProps {
  row: ReportCreative;
  onOpen: (creativeId: string) => void;
}

/** Thumbnail that opens the creative, then a copy-ID icon — for any list, not only a table row. */
export function CreativeThumbLine({ row, onOpen }: CreativeCellProps): ReactNode {
  const { creativeId } = row;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
      <ButtonBase
        disabled={creativeId === null}
        onClick={() => creativeId !== null && onOpen(creativeId)}
        aria-label={`Open creative ${creativeId ?? row.assetId}`}
        sx={{ borderRadius: 1 }}
      >
        <ThumbnailPreview
          name={creativeId ?? row.assetId}
          size={THUMB_SIZE}
          thumbnailUrl={row.thumbnailUrl}
          previewUrl={row.previewUrl}
        />
      </ButtonBase>
      {creativeId === null ? row.assetId : <CreativeIdLine creativeId={creativeId} idHidden />}
    </Box>
  );
}

export function CreativeCell(props: CreativeCellProps): ReactNode {
  return (
    <TableCell sx={{ color: 'text.muted' }}>
      <CreativeThumbLine {...props} />
    </TableCell>
  );
}
